import React, { useEffect, useState } from "react";
import { getAuthHeader } from "../../api/authToken.js";
import { Chart } from "react-google-charts"; // Для діаграми
import "../../styles/App.css";
import { exportToExcel } from "../../components/ExportToExcel.js";


const ReportsPage = () => {
  const [violations, setViolations] = useState([]);
  const [filteredViolations, setFilteredViolations] = useState([]);
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });
  const [filterTypes, setFilterTypes] = useState({
    showActs: true,
    showWarnings: true,
  });
  const [searchName, setSearchName] = useState("");
  const API = process.env.REACT_APP_API_BASE;

  useEffect(() => {
    fetch(`${API}/api/report`, {
      headers: { Authorization: getAuthHeader() },
    })
      .then((res) => res.json())
      .then((data) => {
        setViolations(data.violations);
        setFilteredViolations(data.violations);
      })
      .catch((err) => console.error("Помилка отримання звітності:", err));
  }, []);

  useEffect(() => {
    let filtered = violations;

    // Фільтр за типом
    if (!filterTypes.showActs || !filterTypes.showWarnings) {
      filtered = filtered.filter((violation) => {
        if (filterTypes.showActs && violation.type === "act") return true;
        if (filterTypes.showWarnings && violation.type === "warning")
          return true;
        return false;
      });
    }

    // Фільтр за датою
    if (dateFilter.from) {
      filtered = filtered.filter(
        (violation) => new Date(violation.date) >= new Date(dateFilter.from)
      );
    }
    if (dateFilter.to) {
      filtered = filtered.filter(
        (violation) => new Date(violation.date) <= new Date(dateFilter.to)
      );
    }

    // Фільтр за ПІБ
    if (searchName.trim() !== "") {
      filtered = filtered.filter((violation) =>
        violation.student_name.toLowerCase().includes(searchName.toLowerCase())
      );
    }

    setFilteredViolations(filtered);
  }, [dateFilter, filterTypes, searchName, violations]);

  const chartData = [
    ["Студент", "Порушення/Акти"],
    ...filteredViolations.reduce((acc, violation) => {
      const student = acc.find((item) => item[0] === violation.student_name);
      if (student) {
        student[1] += 1;
      } else {
        acc.push([violation.student_name, 1]);
      }
      return acc;
    }, []),
  ];

  const [sortField, setSortField] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");

  const handleSort = (field) => {
    const newOrder =
      sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(newOrder);
  };

  const sortedViolations = [...filteredViolations].sort((a, b) => {
    if (!sortField) return 0;
    if (a[sortField] < b[sortField]) return sortOrder === "asc" ? -1 : 1;
    if (a[sortField] > b[sortField]) return sortOrder === "asc" ? 1 : -1;
    return 0;
  });

  return (
    <div className="page-container">
      <div className="header-content">
        <input
          type="text"
          id="search-name"
          value={searchName}
          onChange={(e) => setSearchName(e.target.value)}
          placeholder="Пошук за ПІБ"
          className="header-content-input"
        />

        <div className="header-content-date">
          <label htmlFor="from-date">З</label>
          <input
            className="header-content-select"
            type="date"
            id="from-date"
            value={dateFilter.from}
            onChange={(e) =>
              setDateFilter((prev) => ({ ...prev, from: e.target.value }))
            }
          />
          <label htmlFor="to-date">до</label>
          <input
            className="header-content-select"
            type="date"
            id="to-date"
            value={dateFilter.to}
            onChange={(e) =>
              setDateFilter((prev) => ({ ...prev, to: e.target.value }))
            }
          />
        </div>

        <div className="header-content-date">
          <label>
            <input
              type="checkbox"
              checked={filterTypes.showActs}
              onChange={(e) =>
                setFilterTypes((prev) => ({
                  ...prev,
                  showActs: e.target.checked,
                }))
              }
            />
            Показувати акти
          </label>

          <label>
            <input
              type="checkbox"
              checked={filterTypes.showWarnings}
              onChange={(e) =>
                setFilterTypes((prev) => ({
                  ...prev,
                  showWarnings: e.target.checked,
                }))
              }
            />
            Показувати попередження
          </label>
        </div>
      </div>

      <div className="table-container">
        <h1 className="text-header">Таблиця порушень</h1>
        <a
          href="#"
          onClick={() =>
            exportToExcel(
              filteredViolations,
              "Порушення студентів",
              "Звіт_порушення.xlsx",
              (violation) => ({
                Дата: violation.date,
                Тип:
                  violation.type === "act"
                    ? "Акт"
                    : violation.type === "warning"
                    ? "Попередження"
                    : "Невідомий тип",
                Причина: violation.reason,
                Студент: violation.student_name || "—",
                Кімната: violation.dormitory_name,
                Гуртожиток: violation.room_number,
                Фото: violation.file_url || "—",
              })
            )
          }
          className="propese-button"
        >
          Експортувати в Excel
        </a>
        <table className="table">
          <thead>
            <tr>
              <th className="table-header">#</th>
              <th className="table-header" onClick={() => handleSort("date")}>
                Дата{" "}
                {sortField === "date"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th className="table-header" onClick={() => handleSort("type")}>
                Тип{" "}
                {sortField === "type"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th className="table-header" onClick={() => handleSort("reason")}>
                Причина{" "}
                {sortField === "reason"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("student_name")}
              >
                Студент{" "}
                {sortField === "student_name"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("room_number")}
              >
                Кімната{" "}
                {sortField === "room_number"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
              <th
                className="table-header"
                onClick={() => handleSort("file_url")}
              >
                Фото{" "}
                {sortField === "file_url"
                  ? sortOrder === "asc"
                    ? "↑"
                    : "↓"
                  : "↑↓"}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedViolations.map((violation, index) => (
              <tr key={violation.act_id}>
                <td className="table-content">{index + 1}</td>
                <td className="table-content">{violation.date}</td>
                <td className="table-content">
                  {violation.type === "act"
                    ? "Акт"
                    : violation.type === "warning"
                    ? "Попередження"
                    : "Невідомий тип"}
                </td>
                <td className="table-content">{violation.reason}</td>
                <td className="table-content">{violation.student_name}</td>
                <td className="table-content">
                  {violation.dormitory_name} - {violation.room_number}
                </td>
                <td className="table-content">
                  {violation.file_url && (
                    <a
                      href={violation.file_url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Переглянути фото/файл
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="chart-container">
        <h1 className="text-header">Кількість порушень по студентах</h1>
        <Chart
          chartType="Bar"
          width="100%"
          height="400px"
          data={chartData}
          options={{
            title: "Кількість порушень по студентах",
            legend: { position: "none" },
          }}
        />
      </div>
    </div>
  );
};

export default ReportsPage;
